export type UnsplashResult = {
	id: string;
	altDescription: string;
	smallSizeImageUrl: string;
	fullSizeImageUrl: string;
	artistName: string;
	artistUrl: string;
	downloadLink: string;
};

export type SelectedImage = {
	fullSizeImageUrl: string;
	altDescription: string;
	downloadLink?: string;
};

export enum ThumbnailType {
	UNSPLASH_DEFAULT_IMAGE,
	UNSPLASH_IMAGE,
	CUSTOM_IMAGE,
	EXTERNAL_SITE_IMAGE,
	NO_IMAGE,
}

export type UnsplashImage = {
	fullSizeImageUrl: string;
	altDescription?: string;
};

export type UploadedImage = {
	uploadedImageId: string;
	altDescription: string;
};

export type CustomImage = {
	imageId: string;
};

export type Thumbnail = {
	type: ThumbnailType;
	image: UnsplashResult | UnsplashImage | CustomImage | string | undefined;
};

export type GenericUnsplashImage = {
	smallSizeImageUrl: string;
	fullSizeImageUrl: string;
	description: string;
	isSelected: boolean;
	index: number;
	downloadLink?: string;
};
